import { Component, OnInit, AfterViewInit } from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import { ApiService } from "../api.service";

@Component({
  selector: 'app-case-practice-cooperation',
  templateUrl: './case-practice-cooperation.component.html',
  styleUrls: ['./case-practice-cooperation.component.css']
})
export class CasePracticeCooperationComponent implements OnInit {
    learningPathId: number;
    practiceMetaId: number;

    page: string;

    practiceList: any;
    practiceId: number;

    exerciseId: number;

    practiceIndex: number;
    isPC: boolean;
    type : string //是否为pc横版

  constructor(
      private route: ActivatedRoute,
      private router: Router,
      private  apiService: ApiService
  ) { }

  ngOnInit() {
    this.route.queryParams.subscribe(queryParams=>{
      this.type = queryParams['type']
      if(this.type){
        localStorage.setItem('isPC',this.type);
      }
    })
      this.route.params.subscribe(params => {
          this.learningPathId = params['learningPathId'];
          this.practiceMetaId = params['practiceMetaId'];
          this.exerciseId = params['exerciseId'];
          this.isPC = !!localStorage.getItem('isPC');
          if(this.exerciseId>0 || localStorage.getItem('isIframe')){
              this.page = 'video';
          }else{
              this.page = 'list';
          }

          this.apiService.ajax({
              'type':'post',
              'url':'/api/'+this.learningPathId+'/'+this.practiceMetaId+'/createAndGet'
          }).subscribe(result=>{
              this.practiceList = result.exercise;
              this.practiceId = result.id;
            this.apiService.ajax({
              'type': 'post',
              'url': 'sr/practice/correctLearningPath/'+this.practiceId,
              'data': {'practiceId':this.practiceId}
            }).subscribe(result=>{
              console.log(result);
            });
          });

          console.log(this.page)
      });

      setTimeout(()=>{
        if(this.type){
          $('#userIdContainer').val(JSON.parse(localStorage.getItem('userInfo'))['userId']);
        }
      },500);
  }

    setPracticeIndex(i){
        this.practiceIndex = i;
        this.exerciseId = this.practiceList[this.practiceIndex].id;
    }

    goToNextStep(i){
        console.log(i)
        if(i==1){
            this.page = 'video';
        }else if(i==2){
            this.page = 'begin';
        }else if(i==3){
            this.page = 'question';
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/case-practice-cooperation/case-practice-cooperation.component.ts